import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InstallationPickerSheet } from "../installation/InstallationPickerSheet";

const PhotoCaptureReferenceSheet = ({
  open,
  value,
  onChange,
  onDismiss,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [draftReference, setDraftReference] = useState(value);

  useEffect(() => {
    if (open) {
      setDraftReference(value);
    }
  }, [open, value]);

  const handleCancel = () => {
    onDismiss();
  };

  const handleValidate = () => {
    onChange(draftReference.trim());
    onDismiss();
  };

  return (
    <InstallationPickerSheet
      open={open}
      title={t("Identification reference")}
      onSheetCancel={handleCancel}
      onSheetValidate={handleValidate}
      keyboardAware
    >
      <label className="photo-capture-reference-sheet-field">
        <input
          type="text"
          className="photo-capture-metadata-reference-input"
          value={draftReference}
          onChange={(event) => setDraftReference(event.target.value)}
          placeholder={t("Enter reference")}
          disabled={disabled}
          autoComplete="off"
          enterKeyHint="done"
        />
      </label>
    </InstallationPickerSheet>
  );
};

export default PhotoCaptureReferenceSheet;
